<template>
  <IndicationsTabs>
    <slot></slot>
  </IndicationsTabs>
</template>

<script>
import IndicationsTabs from "./IndicationsTabs";

export default {
  components: {
    IndicationsTabs
  }
};
</script>

<style scoped>
.indications-background {
  padding: 20px;
  background-color: white;
}
</style>
